module.exports = __webpack_public_path__ + "img/cropt-event.d2cc1f20.jpg";